function convertMarkdownLinksToHTML(string: string) {
  const pattern = /\[([^\]]+)\]\((http[s]?:\/\/[^)]+)\)/g;

  const replaced = string.replace(pattern, '<a href="$2" target="_blank">$1</a>');

  return replaced;
}

export default convertMarkdownLinksToHTML;
